<template>
  <div class="w-72 md:w-96 mb-4">
    <div class="overflow-hidden h-4 text-xs flex rounded border border-gray-300">
      <div
        :style="`width:${100 - remainingTimePercent}%`"
        v-bind="switchColor(remainingTimePercent)"
        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center">
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  remainingTimePercent: {
    type: Number,
    required: true,
  },
})

const switchColor = (percentage) => {
  if (percentage > 80) return { class: 'bg-red-500' }
  if (percentage > 60) return { class: 'bg-yellow-500' }
  if (percentage > -1) return { class: 'bg-green-500' }
  return {}
}
</script>
